import Vue from 'vue';
import Vuex from 'vuex';
import api from "@/store/modules/api";
import basic from "@/store/modules/basic";
import auth from "@/store/modules/auth";
import unreadNotificationsAlerts from "@/store/modules/unread-notifications-alerts";
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";

var ls = new SecureLS({isCompression: false});

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {},
    actions: {},
    mutations: {},
    getters: {},
    modules: {
        api, basic, auth, unreadNotificationsAlerts
    },
    plugins: [
        createPersistedState({
            paths: ['auth', 'basic.theme', 'basic.organizations', 'basic.organizationId', 'basic.organizationRole'],
            storage: {
                getItem: (key) => {
                    try {
                        const rememberMe = JSON.parse(ls.get('vuex')).auth.RememberMe;
                        if (rememberMe) {
                            return ls.get(key);
                        } else {
                            auth.state.RememberMe = false;
                            auth.state.AuthToken = null;
                            if (!sessionStorage.getItem('newSession')) {
                                return '';
                            }
                        }
                    } catch {
                        return ls.get(key);
                    }

                    return ls.get(key);
                },
                setItem: (key, value) => {
                    if (ls.get(key) && value) {
                        try {
                            const currentDate = Date.parse(JSON.parse(value).auth.user.expiration),
                                storageDate = Date.parse(JSON.parse(ls.get(key)).auth.user.expiration);
                            if (storageDate > currentDate) {
                                return;
                            }

                        }
                            // eslint-disable-next-line no-empty
                        catch {
                        }
                    }

                    ls.set(key, value);
                },
                removeItem: (key) => ls.remove(key),
            },
        }),
    ],
});

export default store;